exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-fly-add-files-button[data-v-4cf8ac12]{position:absolute;right:15px;top:32px;z-index:10}.detail-widget__top[data-v-4cf8ac12]{position:relative;color:#fff;background-color:#0d6247;padding:15px 1.5rem 15px 3rem;min-height:60px}.detail-widget__back[data-v-4cf8ac12]{font-size:200%;position:absolute;left:10px;top:15px}.task-copy-button[data-v-4cf8ac12]{width:15px;height:15px;display:flex;align-items:center;margin-right:2px;padding:0;border:none;outline:none;background-color:transparent;color:#5a6268}", ""]);

// exports
